import { SGBPApplicationFormData } from "../data/SGBPApplicationFormData";


export const setAllDropDownField = (apiResponse) => {
    const filterDropDownList = (dropdownName) => {
        let list = apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                });
            }
            return acc;
        }, []);

        return list;
    };

    const dropdownLists = {
        "typeOfCompany": filterDropDownList("Type Of Company"),
        "applicantRole": filterDropDownList("Products And Service Roles"),
        "mainContactPhone": filterDropDownList("Country Code"),
        "serviceCategory": filterDropDownList("Product Category"),
        "placeofManufacturing": filterDropDownList("Products Country"),
        "mainContactPerson": filterDropDownList("Main Contact Person"),
        "criteria": filterDropDownList("Approved Criteria"),
    };

    const formFields = [...SGBPApplicationFormData.formFields,];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
};

export const setmainContactFields = (apiResponse) => {
    const filterDropDownList = (dropdownName) => {
        let list = apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                });
            }
            return acc;
        }, []);

        return list;
    };

    const dropdownLists = {
        "mainContactPerson": filterDropDownList("Main Contact Person"),

    };

    const formFields = [...SGBPApplicationFormData.formFields,];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
};



export const setProductDetailsDropDown = (apiResponse,categoryKey,subCategoryKey) => {    
    const filterDropDownList = (dropdownName) => {
        let list = apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                });
            }
            return acc;
        }, []);

        return list;
    };
    const dropdownLists = {
        "subCategory": filterDropDownList(categoryKey),
        "productType": filterDropDownList(subCategoryKey),
    };

    const formFields = [...SGBPApplicationFormData.formFields,];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
};